// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"686":"b6bde567","937":"31cb1664"}[chunkId] + ".chunk.css";
};